export const InserisciFeedbackTCB = [
  '',
  `mutation InserisciFeedbackTCB($input: InserisciFeedbackTCBInput!)
    {
        InserisciFeedbackTCB(input: $input )
     }`,
];
